import { Typography, useTheme } from '@mui/material';
import { StatusIndicator } from 'redesign';

const CONTRACT_HOURS_DEVIATION_GREEN_MAX = 3;
const CONTRACT_HOURS_DEVIATION_ORANGE_MIN = -3;

export type ContractHoursChipData = {
  workedMinutes: number | null;
  contractMinutes: number | null;
};

type ContractHoursChipProps = {
  value: ContractHoursChipData | null | undefined;
};

export const ContractHoursChip = ({ value }: ContractHoursChipProps) => {
  const theme = useTheme();
  if (value === null || value === undefined) {
    return <Typography>-</Typography>;
  }
  const { workedMinutes, contractMinutes } = value;
  if (workedMinutes === null || contractMinutes === null) {
    return <Typography>-</Typography>;
  }
  const contractHours = Math.floor(contractMinutes / 60);
  const deviationHours = (workedMinutes - contractMinutes) / 60;
  const roundedDeviation = Math.round(deviationHours);
  const label =
    roundedDeviation === 0
      ? `0 / ${contractHours} uur`
      : `${roundedDeviation > 0 ? '+' : ''}${roundedDeviation} / ${contractHours} uur`;
  const isGreen =
    deviationHours >= CONTRACT_HOURS_DEVIATION_ORANGE_MIN &&
    deviationHours <= CONTRACT_HOURS_DEVIATION_GREEN_MAX;
  const isOrange = deviationHours < CONTRACT_HOURS_DEVIATION_ORANGE_MIN;
  const backgroundColor = isGreen
    ? theme.palette.lwSuccess[20]
    : isOrange
      ? theme.palette.lwWarning[20]
      : theme.palette.lwDanger[20];
  return (
    <StatusIndicator
      backgroundColor={backgroundColor}
      label={label}
      color={theme.palette.lwBlack[100]}
    />
  );
};
